"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.layouts = exports.layoutHeight = exports.layoutWidth = exports.highlightSizeIncrease = exports.borderWidth = exports.videoSpacer = exports.videoSmallHeight = exports.space = exports.reservedHeader = exports.reservedFooter = exports.margin = exports.buttonBarHeight = exports.aspectRatio_16to9 = void 0;
var __1 = require("../../");
exports.aspectRatio_16to9 = 16 / 9; // 16:9; Wide Screen (HDTV); approx 1.78:1
exports.buttonBarHeight = 50;
exports.margin = 12; // theme.spacing(1.5)
exports.reservedFooter = exports.margin * 2 + exports.buttonBarHeight; // margin + 50 for buttons + margin
exports.reservedHeader = 38;
exports.space = 8;
exports.videoSmallHeight = 90;
exports.videoSpacer = 4; // theme.spacing(0.5)
exports.borderWidth = 2;
exports.highlightSizeIncrease = 1.03; // 3 percent bigger in width
// The layouts below are defined in 4k resolution
exports.layoutWidth = 3840;
exports.layoutHeight = 2160;
// This defines the video tile sizes and positions for talker layout
// Each key indicates the minimum number of videos in the layout for which this is used
// Each value is an array of positions for each of the video tiles in the layout
// Each position is an array of width, height, x offset and y offset
var talkerLayout = new Map([
    [0, [
            [3840, 2160, 0, 0]
        ]],
    [2, [
            [3200, 1800, 320, 360],
            [640, 360, 0, 0],
            [640, 360, 640, 0],
            [640, 360, 1280, 0],
            [640, 360, 1920, 0],
            [640, 360, 2560, 0],
            [640, 360, 3200, 0]
        ]]
]);
// This defines the video tile sizes and positions for legacy layout
var legacyLayout = new Map([
    [0, [
            [3840, 2160, 0, 0]
        ]],
    [2, [
            [2880, 1620, 480, 0],
            [960, 540, 960, 1620],
            [960, 540, 1920, 1620],
            [960, 540, 0, 1620],
            [960, 540, 2880, 1620]
        ]],
    [6, [
            [2880, 1620, 0, 0],
            [960, 540, 2880, 0],
            [960, 540, 2880, 540],
            [960, 540, 2880, 1080],
            [960, 540, 0, 1620],
            [960, 540, 960, 1620],
            [960, 540, 1920, 1620],
            [960, 540, 2880, 1620]
        ]],
    [9, [
            [1920, 1080, 960, 270],
            [960, 540, 2880, 270],
            [960, 540, 2880, 810],
            [960, 540, 2880, 1350],
            [960, 540, 0, 1350],
            [960, 540, 960, 1350],
            [960, 540, 1920, 1350],
            [960, 540, 0, 270],
            [960, 540, 0, 810]
        ]]
]);
// This defines the video tile sizes and positions for panel layout
var panelLayout = new Map([
    [0, [
            [3840, 2160, 0, 0]
        ]],
    [2, [
            [2880, 1620, 0, 486],
            [960, 540, 2880, 486],
            [960, 540, 2880, 1026],
            [960, 540, 2880, 1566],
            [768, 432, 0, 54],
            [768, 432, 768, 54],
            [768, 432, 1536, 54],
            [768, 432, 2304, 54],
            [768, 432, 3072, 54]
        ]]
]);
// This defines the video tile sizes and positions for gallery layout
var galleryLayout = new Map([
    [0, [
            [3840, 2160, 0, 0]
        ]],
    [2, [
            [1920, 1080, 0, 540],
            [1920, 1080, 1920, 540]
        ]],
    [3, [
            [1920, 1080, 0, 0],
            [1920, 1080, 1920, 0],
            [1920, 1080, 960, 1080]
        ]],
    [4, [
            [1920, 1080, 0, 0],
            [1920, 1080, 1920, 0],
            [1920, 1080, 0, 1080],
            [1920, 1080, 1920, 1080],
        ]],
    [5, [
            [1280, 720, 0, 360],
            [1280, 720, 1280, 360],
            [1280, 720, 0, 1080],
            [1280, 720, 1280, 1080],
            [1280, 720, 2560, 360],
            [1280, 720, 2560, 1080]
        ]],
    [7, [
            [1280, 720, 0, 0],
            [1280, 720, 1280, 0],
            [1280, 720, 0, 720],
            [1280, 720, 1280, 720],
            [1280, 720, 2560, 0],
            [1280, 720, 2560, 720],
            [1280, 720, 1280, 1440],
            [1280, 720, 0, 1440],
            [1280, 720, 2560, 1440]
        ]]
]);
// This map contains all the layouts indexed by layout key
exports.layouts = new Map([
    [__1.constants.SFU_LAYOUT_LEGACY, legacyLayout],
    [__1.constants.SFU_LAYOUT_TALKER, talkerLayout],
    [__1.constants.SFU_LAYOUT_GALLERY, galleryLayout],
    [__1.constants.SFU_LAYOUT_PANEL, panelLayout]
]);
